import { ErrorBoundaryProvider } from '@betty/navigation';
import React, { Suspense } from 'react';

export const lazyRoute = (
  importFn: () => Promise<{ default: React.ComponentType }>,
) => {
  const Component = React.lazy(importFn);

  return (
    <ErrorBoundaryProvider>
      <Suspense
        fallback={
          <div style={{ height: 'var(--inner-height)' }}>Loading...</div>
        }
      >
        <Component />
      </Suspense>
    </ErrorBoundaryProvider>
  );
};
